module.exports = __webpack_public_path__ + "img/completedIconUS.42301146.png";